var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "save-form" }, [
    _c("div", { staticClass: "save-field" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formObject.name,
            expression: "formObject.name",
          },
        ],
        staticClass: "save-input",
        attrs: {
          id: "saveQueryName",
          type: "text",
          maxlength: "256",
          autocomplete: "off",
          disabled: _vm.disabled,
          "aria-invalid": _vm.nameError ? "true" : "false",
          "aria-describedby": "saveNameHint",
        },
        domProps: { value: _vm.formObject.name },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formObject, "name", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "save-hint", attrs: { id: "saveNameHint" } }, [
        _vm._v(
          "Choose a clear name; including analytes, locations, or dates can help identify the query."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "save-counter" }, [
        _c("span", [_vm._v(_vm._s(_vm.nameLength))]),
        _vm._v(" / 256"),
      ]),
      _vm._v(" "),
      _vm.nameError
        ? _c("div", { staticClass: "save-error" }, [
            _vm._v(_vm._s(_vm.nameError)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "save-field" }, [
      _c(
        "label",
        { staticClass: "save-label", attrs: { for: "saveQueryDescription" } },
        [_vm._v("Description")]
      ),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formObject.description,
            expression: "formObject.description",
          },
        ],
        staticClass: "save-input save-textarea",
        attrs: {
          id: "saveQueryDescription",
          maxlength: "512",
          disabled: _vm.disabled,
          "aria-describedby": "saveDescriptionHint",
        },
        domProps: { value: _vm.formObject.description },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.formObject, "description", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "save-hint", attrs: { id: "saveDescriptionHint" } },
        [_vm._v("Describe the purpose of this query.")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "save-counter" }, [
        _c("span", [_vm._v(_vm._s(_vm.descriptionLength))]),
        _vm._v(" / 512"),
      ]),
      _vm._v(" "),
      _vm.descriptionError
        ? _c("div", { staticClass: "save-error" }, [
            _vm._v(_vm._s(_vm.descriptionError)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "save-field" }, [
      _c(
        "label",
        { staticClass: "save-toggle", attrs: { for: "saveRelativeDates" } },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hasRelativeDates,
                expression: "hasRelativeDates",
              },
            ],
            attrs: {
              id: "saveRelativeDates",
              type: "checkbox",
              disabled: _vm.disabled,
            },
            domProps: {
              checked: Array.isArray(_vm.hasRelativeDates)
                ? _vm._i(_vm.hasRelativeDates, null) > -1
                : _vm.hasRelativeDates,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.hasRelativeDates,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.hasRelativeDates = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.hasRelativeDates = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.hasRelativeDates = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("v-icon", { attrs: { small: "" } }, [_vm._v("date_range")]),
          _vm._v(" "),
          _c("span", [_vm._v("Relative dates")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "save-hint" },
        [
          _vm.hasRelativeDates
            ? [
                _vm._v("Date range is saved "),
                _c("strong", [_vm._v("relative to the view date")]),
                _vm._v(". Uncheck this to save exact dates."),
              ]
            : [
                _vm._v("Date range is saved "),
                _c("strong", [_vm._v("exactly as defined")]),
                _vm._v(". Enable this to save it relative to the view date."),
              ],
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "save-field" }, [
      _c(
        "label",
        { staticClass: "save-toggle", attrs: { for: "saveShared" } },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formObject.isShared,
                expression: "formObject.isShared",
              },
            ],
            attrs: {
              id: "saveShared",
              type: "checkbox",
              disabled: _vm.disabled,
            },
            domProps: {
              checked: Array.isArray(_vm.formObject.isShared)
                ? _vm._i(_vm.formObject.isShared, null) > -1
                : _vm.formObject.isShared,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.formObject.isShared,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.formObject, "isShared", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.formObject,
                        "isShared",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.formObject, "isShared", $$c)
                }
              },
            },
          }),
          _vm._v(" "),
          _c("v-icon", { attrs: { small: "" } }, [_vm._v("share")]),
          _vm._v(" "),
          _c("span", [_vm._v("Share with others")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "save-hint" }, [
        _vm._v(
          _vm._s(
            _vm.formObject.isShared
              ? "Users with access to the data can use this query, but cannot edit it."
              : "Only you can use this query."
          )
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.isSomeAdmin
      ? _c(
          "section",
          {
            staticClass: "save-admin",
            attrs: { "aria-labelledby": "saveAdminTitle" },
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "save-field" }, [
              _c(
                "label",
                { staticClass: "save-label", attrs: { for: "saveQueryUser" } },
                [_vm._v("User")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formObject.userId,
                      expression: "formObject.userId",
                    },
                  ],
                  staticClass: "save-input",
                  attrs: {
                    id: "saveQueryUser",
                    disabled: _vm.disabled,
                    "aria-describedby": "saveUserHint",
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formObject,
                        "userId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Assign to yourself"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.users, function (user) {
                    return _c(
                      "option",
                      { key: user.UserId, domProps: { value: user.UserId } },
                      [_vm._v(_vm._s(user.UserName))]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "save-hint", attrs: { id: "saveUserHint" } },
                [
                  _vm._v(
                    "Assign this query to another user, or leave empty to assign it to yourself."
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.userError
                ? _c("div", { staticClass: "save-error" }, [
                    _vm._v(_vm._s(_vm.userError)),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "save-label", attrs: { for: "saveQueryName" } },
      [
        _vm._v("Name "),
        _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("*")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h3",
      { staticClass: "save-section-title", attrs: { id: "saveAdminTitle" } },
      [
        _vm._v("Administration "),
        _c("span", { staticClass: "save-admin-note" }, [_vm._v("Admin only")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }